<template>
  <div class="animated fadeIn" id="liberacao-horas">
    <div class="card card-default">
      <div class="card-header">
        <i class="icon-hourglass"></i> Liberação de Horas - EPS
      </div>
      <div class="card-body">
        <div class="row">
          <div class="form-group col-md-4 col-xs-12 col-sm-12">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span for="profissional" class="input-group-text">Profissional</span>
              </div>
              <select id="profissional" class="form-control" v-model="cadastro.usuario_id">
                <option value="">Selecione...</option>
                <option v-for="usuario of dados.usuarios" v-bind:key="usuario.id" :value="usuario.id">{{ usuario.nome }} - {{ usuario.email }}</option>
              </select>
            </div>
          </div>

          <div class="form-group col-md-4 col-xs-12 col-sm6">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="profissional" style="width: 90px;">Data Inicial</span>
              </div>
              <date-picker input-class="form-control"
                           v-model="cadastro.data_inicial"
                           lang="pt-br"
                           format="DD/MM/YYYY"
                           style="height: calc(100% - 90px);">
              </date-picker>
            </div>
          </div>

          <div class="form-group col-md-4 col-xs-12 col-sm6">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="profissional" style="width: 90px;">Data Final</span>
              </div>
              <date-picker input-class="form-control"
                           v-model="cadastro.data_final"
                           lang="pt-br"
                           format="DD/MM/YYYY"
                           style="height: calc(100% - 90px);">
              </date-picker>
            </div>
          </div>

          <div class="form-group col-md-3 col-xs-12 col-sm-6">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span for="quantidade-horas" class="input-group-text" id="profissional">Quantidade</span>
              </div>
              <input id="quantidade-horas" class="form-control" type="time" v-model="cadastro.quantidade">
            </div>
          </div>
        </div>

        <button class="btn btn-primary pull-right" :disabled="!valoresValidos" v-on:click="salvar"><i class="icon-check"></i> Salvar</button>
        <button class="btn btn-default pull-right" style="margin-right: 5px;" v-on:click="limparDados"><i class="icon-action-undo"></i> Cancelar</button>
      </div>
    </div>

    <div class="card card-default">
      <div class="card-header">
        <i class="icon-book-open"></i> Histórico de Liberação de Horas - EPS
      </div>
      <div class="card-body">
        <datatable-panel :per-page="30"
          :url="`${$root.url}/hora-liberada?token=${$root.usuario('access_token')}`"
          :fields="fields"
          :sortField="fields[0]"
          ref="datatable"
          :searchBar="searchBar">
        </datatable-panel>
      </div>
    </div>

    <notifications group="liberacao-horas" />
  </div>
</template>

<style lang="scss">
  #liberacao-horas {
    .search-bar {
      & .container-fluid {
        padding-left: 0;

        & button {
          margin-left: 15px;
        }
      }
    }
  }
</style>

<script>
import DatatablePanel from 'metawesome-datatable';
import SearchBar from './SearchBar';
import DatePicker from 'vue2-datepicker';
import Uteis from '@/mixins/utils.js';
import { throws } from 'assert';

export default {
  components: {
    DatePicker,
    DatatablePanel,
  },

  mixins: [
    Uteis
  ],

  data() {
    return {
      searchBar: SearchBar,
      cadastro: {
        usuario_id: '',
        data_inicial: '',
        data_final: '',
        quantidade: '',
      },
      dados: {
        usuarios: [],
      },
      fields: [
        { name: 'usuario', sortField: 'usuario', title: 'Usuário' },
        { name: 'data', sortField: 'data', title: 'Data', callback: this.formatarDataString },
        { name: 'quantidade', sortField: 'quantidade', title: 'Quantidade', callback: this.getDuracao },
        { name: 'responsavel', sortField: 'responsavel', title: 'Usuário Responsável' },
      ],
    };
  },

  computed: {
    valoresValidos() {
      return this.cadastro.usuario_id &&
        this.cadastro.data_inicial &&
        this.cadastro.data_final &&
        this.cadastro.quantidade;
    }
  },

  mounted() {
    this.carregarProfissionais();
  },

  methods: {
    async salvar() {
      if (!this.validarDatas()) {
        return false;
      }

      try {
        this.$events.$emit('loading', true);

        const { data: response } = await this.$http.post('/eps', this.getDto());

        if (!response.success) {
          throw new Error();
        }

        this.limparDados();
        this.notificar('Cadastro realizado com sucesso!', 'liberacao-horas', 'success');
      } catch(e) {
        this.notificar('Ocorreu um erro ao cadastrar as Horas Excedentes.', 'liberacao-horas');
      } finally {
        this.$events.$emit('loading', false);
        this.$refs.datatable.$refs.datatable.reload();
      }
    },

    getDto() {
      const horas = this.cadastro.quantidade.split(':');

      return {
        inicio: new Date(this.cadastro.data_inicial).toISOString().slice(0, 10),
        fim: new Date(this.cadastro.data_final).toISOString().slice(0, 10),
        quantidade: this.getSegundos(horas[0], horas[1]),
        usuario_id: this.cadastro.usuario_id,
      };
    },

    limparDados() {
      for (let index in this.cadastro) {
        this.cadastro[index] = '';
      }
    },

    validarDatas() {
      const dtInicial = new Date(this.cadastro.data_inicial);
      const dtFinal = new Date(this.cadastro.data_final);

      if (dtInicial > dtFinal) {
        this.notificar('A data inicial deve ser menor ou igual à data final', 'liberacao-horas');
        return false;
      }

      return true;
    },

    async carregarProfissionais() {
      try {
        const { data: response } = await this.$http.get('/v-usuario/list');

        this.dados.usuarios = response.usuarios;
      } catch(e) {
        this.notificar('Ocorreu um erro ao carregar os Usuários', 'liberacao-horas');
      }
    },

    formatarDataString(value) {
      const data = value.split('-');

      return `${data[2]}/${data[1]}/${data[0]}`;
    },
  },
}
</script>
